export default function validatePasswordStrength() {
  return (_, newValue) => {
    const errorMessage = "Le mot de passe doit contenir 8 caractères dont des majuscules, des minuscules et des chiffres, ou au moins 16 caractères sans restriction";
    if (newValue == null) return errorMessage;
    if (newValue.length > 16) return true;
    if (newValue.length < 8) return errorMessage;
    const containsNumbers = /\d/.test(newValue);
    const containsLowerCaseLetters = newValue.toUpperCase() != newValue;
    const containsCapitalLetters = newValue.toLowerCase() != newValue;
    return containsNumbers && containsLowerCaseLetters && containsCapitalLetters || errorMessage;
  };
}